import { decode as base64_decode, encode as base64_encode } from 'base-64';
import RootStore from './RootStore';
import { postApi, baseURL } from '../components/Utility'
import {
    action,

    makeObservable,
    observable,

} from 'mobx';
import config from "../config";
import { message } from "antd";


class ParentPaymentReportStore {
    parentPaymentReport = []
    total = 0
    loading = false
    rootStore

    constructor(rootStore) {
        makeObservable(this, {
            parentPaymentReport: observable,
            total: observable,
            loading: observable,
            loadData: action,
            exportExcel: action,
            exportpdf: action,

        });
        this.rootStore = rootStore;

    }

    async loadData({ offset, limit, companyId, reportType, fromDate, toDate, searchField }) {
        this.loading = true;
        var postData = { "companyId": companyId, "reportType": reportType, "fromDate": fromDate, "toDate": toDate, "offset": offset, "limit": limit, "page": 1, 'searchField': searchField || '' }
        const base64Input = await base64_encode(JSON.stringify(postData));
        var response = await postApi.getClient().post("index.php?c=parent&a=parentPaymentDetailsReport", "postData=" + base64Input);
        this.parentPaymentReport = response?.data?.data?.ReportData || [];
        this.total = parseInt(response?.data?.data?.TotalCount);
        this.loading = false;

    }


    async exportExcel(getData) {
        console.log(getData)
        // debugger
        let lang = "english";
        window.location.href =
            baseURL +
            "index.php?c=parent&a=exportparentPaymentDetailsReportExcel&cid=" +
            getData.companyId +
            "&fD=" +
            getData.fromDate +
            "&tD=" +
            getData.toDate +
            "&colList=" +
            getData.colList +
            "&language=" +
            lang +
            "&searchField=" +
            getData.searchField;

    }

    async exportpdf(getData) {
        let lang = "english";
        window.location.href =
            baseURL +
            "index.php?c=parent&a=exportParentPaymentDetailsReportPdf&cid=" +
            getData.companyId +
            "&vid=" +
            getData.vehicleId +
            "&fD=" +
            getData.fromDate +
            "&tD=" +
            getData.toDate +
            "&colList=" +
            getData.colList +
            "&language=" +
            lang +
            "&searchField=" +
            getData.searchField;

    }

}

export default ParentPaymentReportStore;
